import React from 'react';
import PropTypes from 'prop-types';

import StoreIcon from '../../components/StoreIcon';
import AppIcon from '../../components/AppIcon';

const AppHeader = ({ data }) => {
  const {
    name,
    url,
    icon,
    store,
  } = data;
  return (
    <a href={url} className="breadcrumb-name text-truncate">
      {store &&
        <div className="d-flex align-items-items applications-list justify-content-center pr-xxxs mr-xxxs store-container text-xxxs">
          <StoreIcon store={store} />
        </div>
      }
      <AppIcon
        url={icon}
        store={store}
        size={16}
        alt={name}
        containerClasses="mr-xxxs img-rounded b-a"
      />
      <span className="text-truncate">{name}</span>
    </a>
  );
};

AppHeader.propTypes = {
  data: PropTypes.object.isRequired,
};

export default AppHeader;
